export default "__VITE_ASSET__CM0YWxjO__"